// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type CreateDashboardModalType from './index.tsx';

const AsyncCreateDashboardModal = lazyForPaint(
	() => import(/* webpackChunkName: "async-create-dashboard-modal" */ './index'),
);

const AsyncCreateDashboardModalContainer = (
	props: JSX.LibraryManagedAttributes<
		typeof CreateDashboardModalType,
		ComponentProps<typeof CreateDashboardModalType>
	>,
) => (
	<Placeholder name="create-dashboard-modal" fallback={<></>}>
		<AsyncCreateDashboardModal {...props} />
	</Placeholder>
);

export default AsyncCreateDashboardModalContainer;
